export default __webpack_public_path__ + "9db965b429d1af536fd75c45485a43a1.svg";